import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper, Typography } from "@mui/material";
import { getOffsetOverYears } from "../../../redux/actions";
import useStyles from "./styles";
import StackedColumnChart from "./StackedColumnChart";
import { getCookie } from "../../../services/cookie";

const OffsetOverYears = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const role = getCookie("role");
  const companyId = getCookie("companyId");

  const scopeByYear = useSelector(
    (state) => state.dashboard.getOffsetOverYears.data
  );

  useEffect(() => {
    !props.refreshContent &&
      dispatch(getOffsetOverYears(props.filter, role, companyId));
  }, [dispatch, props.filter]);

  return (
    <Paper className={classes.container}>
      <>
        <Typography className={classes.graphTitle}>Offset over time</Typography>
        {Object.keys(scopeByYear)?.length > 0 ? (
          <div className={classes.chart}>
            <StackedColumnChart
              apiResponse={scopeByYear}
              filter={props.filter}
            />
          </div>
        ) : (
          <div style={{ minHeight: 250 }}>No Data Available</div>
        )}
      </>
    </Paper>
  );
};

export default OffsetOverYears;
